import { app } from '../../../../../app';
import { Controller } from './generate-backup-codes.controller';

app.component('companyUserDirectoriesManageUserGenerateBC', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./generate-backup-codes.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/generate-backup-codes/generate-backup-codes.component.js